export interface AuthProviderProps {
  [key: string]: any;
}

export type Status = 'idle' | 'pending' | 'success' | 'error';

export const STATUS = {
  idle: 'idle',
  pending: 'pending',
  success: 'success',
  error: 'error',
} as const;

export type UserData = {
  active: boolean;
  created_at: string;
  default_payment_method_set: boolean;
  deleted_at: string | null;
  email: string;
  first_name: string | null;
  id: string;
  is_superuser: boolean;
  last_name: string | null;
  updated_at: string;
};

export interface AuthContext {
  user: string | null;
  merchantId: string | null;
  testMode: boolean;
  changePassword: () => void;
  logout: () => void;
  loginWithRedirect: () => void;
}
